//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class BackendApiV7 {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return JWT token, possibly including further authentication details such as a DeviceId and the available users
     */
    postAuthenticate(device_id: string, body: LoginRequestDto, cancelToken?: CancelToken | undefined): Promise<TokenResponseDto> {
        let url_ = this.baseUrl + "/api/v7/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "device-id": device_id !== undefined && device_id !== null ? "" + device_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostAuthenticate(_response);
        });
    }

    protected processPostAuthenticate(response: AxiosResponse): Promise<TokenResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TokenResponseDto.fromJS(resultData200);
            return Promise.resolve<TokenResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the DeviceId isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenResponseDto>(null as any);
    }

    /**
     * @return JWT token, possibly including further authentication details such as a DeviceId and the available users
     */
    refreshToken(device_id: string, body: TokenRefreshRequestDto, cancelToken?: CancelToken | undefined): Promise<TokenResponseDto> {
        let url_ = this.baseUrl + "/api/v7/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "device-id": device_id !== undefined && device_id !== null ? "" + device_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<TokenResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TokenResponseDto.fromJS(resultData200);
            return Promise.resolve<TokenResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the DeviceId isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenResponseDto>(null as any);
    }

    /**
     * @return Returns DeviceId
     */
    postDevice(body: LoginRequestDto, cancelToken?: CancelToken | undefined): Promise<DeviceResponseDto> {
        let url_ = this.baseUrl + "/api/v7/authenticate/device";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostDevice(_response);
        });
    }

    protected processPostDevice(response: AxiosResponse): Promise<DeviceResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeviceResponseDto.fromJS(resultData200);
            return Promise.resolve<DeviceResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceResponseDto>(null as any);
    }

    /**
     * Retrieves Buchten collection for betrieb
     * @param fromDateTimeUtc (optional) Represents the time from which to start filtering Buchten by mofifiedAtUtc date
     * @return In case proper Buchten array is returned
     */
    getBuchten(fromDateTimeUtc: Date | undefined, cancelToken?: CancelToken | undefined): Promise<BuchtenResponseDto> {
        let url_ = this.baseUrl + "/api/v7/buchten?";
        if (fromDateTimeUtc === null)
            throw new Error("The parameter 'fromDateTimeUtc' cannot be null.");
        else if (fromDateTimeUtc !== undefined)
            url_ += "fromDateTimeUtc=" + encodeURIComponent(fromDateTimeUtc ? "" + fromDateTimeUtc.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuchten(_response);
        });
    }

    protected processGetBuchten(response: AxiosResponse): Promise<BuchtenResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BuchtenResponseDto.fromJS(resultData200);
            return Promise.resolve<BuchtenResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BuchtenResponseDto>(null as any);
    }

    /**
     * Send already existing data export again
     * @return In case the data export email has been successfully sent
     */
    sendDataExport(body: SendDataExportRequestDto, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v7/data-export/resend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendDataExport(_response);
        });
    }

    protected processSendDataExport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 202) {
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("In case the user doesn\'t have permissions to resource", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get data overview by id
     * @return In case the data overview has been successfully generated
     */
    getDataOverview(funktionId: number, dataExportConfigurationId: number, cancelToken?: CancelToken | undefined): Promise<DataOverviewDto> {
        let url_ = this.baseUrl + "/api/v7/data-export/data-overview?";
        if (funktionId === undefined || funktionId === null)
            throw new Error("The parameter 'funktionId' must be defined and cannot be null.");
        else
            url_ += "FunktionId=" + encodeURIComponent("" + funktionId) + "&";
        if (dataExportConfigurationId === undefined || dataExportConfigurationId === null)
            throw new Error("The parameter 'dataExportConfigurationId' must be defined and cannot be null.");
        else
            url_ += "DataExportConfigurationId=" + encodeURIComponent("" + dataExportConfigurationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataOverview(_response);
        });
    }

    protected processGetDataOverview(response: AxiosResponse): Promise<DataOverviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataOverviewDto.fromJS(resultData200);
            return Promise.resolve<DataOverviewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataOverviewDto>(null as any);
    }

    /**
     * Retrieves Ferkel collection
     * @param fromDateTimeUtc (optional) Represents the time from which to start filtering of modified/created Ferkel
     * @return In case proper filtered Ferkel array is returned
     */
    getFerkel(fromDateTimeUtc: Date | undefined, cancelToken?: CancelToken | undefined): Promise<FerkelResponseDto> {
        let url_ = this.baseUrl + "/api/v7/ferkel?";
        if (fromDateTimeUtc === null)
            throw new Error("The parameter 'fromDateTimeUtc' cannot be null.");
        else if (fromDateTimeUtc !== undefined)
            url_ += "fromDateTimeUtc=" + encodeURIComponent(fromDateTimeUtc ? "" + fromDateTimeUtc.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFerkel(_response);
        });
    }

    protected processGetFerkel(response: AxiosResponse): Promise<FerkelResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FerkelResponseDto.fromJS(resultData200);
            return Promise.resolve<FerkelResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FerkelResponseDto>(null as any);
    }

    /**
     * Returns all Funktionen available for the current period including the ProzessData and ProzessDataFilters
     * @return List of the Funktionen available for the current period including the ProzessData and ProzessDataFilters
     */
    getFunktionen( cancelToken?: CancelToken | undefined): Promise<FunktionenResponseDto> {
        let url_ = this.baseUrl + "/api/v7/funktionen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFunktionen(_response);
        });
    }

    protected processGetFunktionen(response: AxiosResponse): Promise<FunktionenResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FunktionenResponseDto.fromJS(resultData200);
            return Promise.resolve<FunktionenResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FunktionenResponseDto>(null as any);
    }

    /**
     * Retrieves Plan for Ferkel collection
     * @param fromDateTimeUtc (optional) Represents the time from which to start filtering of new PlanFerkels
     * @return In case PlanFerkel array is returned
     */
    getPlanFerkel(fromDateTimeUtc: Date | undefined, cancelToken?: CancelToken | undefined): Promise<PlanFerkelResponseDto> {
        let url_ = this.baseUrl + "/api/v7/plan/ferkel?";
        if (fromDateTimeUtc === null)
            throw new Error("The parameter 'fromDateTimeUtc' cannot be null.");
        else if (fromDateTimeUtc !== undefined)
            url_ += "fromDateTimeUtc=" + encodeURIComponent(fromDateTimeUtc ? "" + fromDateTimeUtc.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlanFerkel(_response);
        });
    }

    protected processGetPlanFerkel(response: AxiosResponse): Promise<PlanFerkelResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlanFerkelResponseDto.fromJS(resultData200);
            return Promise.resolve<PlanFerkelResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlanFerkelResponseDto>(null as any);
    }

    /**
     * Returns ProcessEvents grouped according to the RecordId for a given RecordIds
     * @return Retrieves captured records
     */
    getCapturedRecordsByIds(body: CapturedRecordsByIdsRequestDto, cancelToken?: CancelToken | undefined): Promise<CapturedRecordsResponseDto> {
        let url_ = this.baseUrl + "/api/v7/prozessEvents/captured-records/findByRecordIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCapturedRecordsByIds(_response);
        });
    }

    protected processGetCapturedRecordsByIds(response: AxiosResponse): Promise<CapturedRecordsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CapturedRecordsResponseDto.fromJS(resultData200);
            return Promise.resolve<CapturedRecordsResponseDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("In case the user doesn\'t have permissions to resource", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CapturedRecordsResponseDto>(null as any);
    }

    /**
     * Deletes ProzessEvents for the specified RecordId (even if they are in group along with other records)
     * @return In case the specified ProzessEvents have been successfully deleted
     */
    deleteProzessEventsByRecord(body: DeleteProzessEventsByRecordRequestDto, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v7/prozess-events/record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProzessEventsByRecord(_response);
        });
    }

    protected processDeleteProzessEventsByRecord(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("In case the specified RecordId cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deletes ProzessEvents for the specified RecordsGroupId
     * @return In case the specified ProzessEvents have been successfully deleted
     */
    deleteProzessEventsByRecordsGroup(body: DeleteProzessEventsByRecordsGroupRequestDto, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v7/prozess-events/recordsgroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProzessEventsByRecordsGroup(_response);
        });
    }

    protected processDeleteProzessEventsByRecordsGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("In case the specified RecordsGroupId cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns ProcessEvents grouped by RecordsGroupId which belongs to DataExport
     * @return Retrieves captured records groups
     */
    getCapturedRecordsGroupsForDataExports(body: CapturedRecordsGroupsRequestDto, cancelToken?: CancelToken | undefined): Promise<CapturedRecordsGroupsResponseDto> {
        let url_ = this.baseUrl + "/api/v7/prozessEvents/capturedRecordsGroups/dataExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCapturedRecordsGroupsForDataExports(_response);
        });
    }

    protected processGetCapturedRecordsGroupsForDataExports(response: AxiosResponse): Promise<CapturedRecordsGroupsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CapturedRecordsGroupsResponseDto.fromJS(resultData200);
            return Promise.resolve<CapturedRecordsGroupsResponseDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("In case the user doesn\'t have permissions to resource", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CapturedRecordsGroupsResponseDto>(null as any);
    }

    /**
     * Returns ProcessEvents grouped according to the RecordsGroupId for a Funktion
     * @return Retrieves captured record groups
     */
    getCapturedRecordsGroups(body: CapturedRecordsGroupsRequestDto, cancelToken?: CancelToken | undefined): Promise<CapturedRecordsGroupsResponseDto> {
        let url_ = this.baseUrl + "/api/v7/prozessEvents/capturedRecordsGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCapturedRecordsGroups(_response);
        });
    }

    protected processGetCapturedRecordsGroups(response: AxiosResponse): Promise<CapturedRecordsGroupsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CapturedRecordsGroupsResponseDto.fromJS(resultData200);
            return Promise.resolve<CapturedRecordsGroupsResponseDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("In case the user doesn\'t have permissions to resource", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CapturedRecordsGroupsResponseDto>(null as any);
    }

    /**
     * Saves the ProzessEvents in the database
     * @return When the data has been successfully transmitted and saved
     */
    postProzessEvents(body: ProzessEventsRequestDto, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v7/prozessEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostProzessEvents(_response);
        });
    }

    protected processPostProzessEvents(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("In case the user doesn\'t have permissions to resource", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Saves the ProzessEvents in the database
     * @return Retrieves captured records groups
     */
    postProzessEventsSynchronously(body: ProzessEventsRequestDto, cancelToken?: CancelToken | undefined): Promise<CapturedRecordsGroupsResponseDto> {
        let url_ = this.baseUrl + "/api/v7/prozess-events/synchronously";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostProzessEventsSynchronously(_response);
        });
    }

    protected processPostProzessEventsSynchronously(response: AxiosResponse): Promise<CapturedRecordsGroupsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProzessEventsValidationResultDto.fromJS(resultData400);
            return throwException("In case the FileContent is mismatch to the correspond request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CapturedRecordsGroupsResponseDto.fromJS(resultData200);
            return Promise.resolve<CapturedRecordsGroupsResponseDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("In case the user doesn\'t have permissions to resource", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CapturedRecordsGroupsResponseDto>(null as any);
    }

    /**
     * Saves received problem report into the database
     * @return In case the report was successfully saved
     */
    saveProblemReport(body: ProblemReportDto, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v7/problem-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveProblemReport(_response);
        });
    }

    protected processSaveProblemReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieves filtered Sauen collection
     * @param fromDateTimeUtc (optional) Represents the time from which to start filtering of modified/created Sauen
     * @return In case proper filtered Sauen array is returned
     */
    getFilteredSauen(fromDateTimeUtc: Date | undefined, cancelToken?: CancelToken | undefined): Promise<SauenResponseDto> {
        let url_ = this.baseUrl + "/api/v7/sauen?";
        if (fromDateTimeUtc === null)
            throw new Error("The parameter 'fromDateTimeUtc' cannot be null.");
        else if (fromDateTimeUtc !== undefined)
            url_ += "fromDateTimeUtc=" + encodeURIComponent(fromDateTimeUtc ? "" + fromDateTimeUtc.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilteredSauen(_response);
        });
    }

    protected processGetFilteredSauen(response: AxiosResponse): Promise<SauenResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SauenResponseDto.fromJS(resultData200);
            return Promise.resolve<SauenResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SauenResponseDto>(null as any);
    }

    /**
     * Gibt Übersetzungen für eine bestimmte Sprache zurück
     * @return Übersetzungen
     */
    getTranslations( cancelToken?: CancelToken | undefined): Promise<TranslationsResponseDto> {
        let url_ = this.baseUrl + "/api/v7/translations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTranslations(_response);
        });
    }

    protected processGetTranslations(response: AxiosResponse): Promise<TranslationsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TranslationsResponseDto.fromJS(resultData200);
            return Promise.resolve<TranslationsResponseDto>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal server error.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationsResponseDto>(null as any);
    }

    /**
     * @return List of all users belonging to the company
     */
    getUsersList(device_id: string, cancelToken?: CancelToken | undefined): Promise<UsersResponseDto> {
        let url_ = this.baseUrl + "/api/v7/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "device-id": device_id !== undefined && device_id !== null ? "" + device_id : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersList(_response);
        });
    }

    protected processGetUsersList(response: AxiosResponse): Promise<UsersResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UsersResponseDto.fromJS(resultData200);
            return Promise.resolve<UsersResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UsersResponseDto>(null as any);
    }

    /**
     * @return Current user including settings
     */
    getCurrentUser( cancelToken?: CancelToken | undefined): Promise<UserResponseDto> {
        let url_ = this.baseUrl + "/api/v7/users/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: AxiosResponse): Promise<UserResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserResponseDto.fromJS(resultData200);
            return Promise.resolve<UserResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResponseDto>(null as any);
    }

    /**
     * Creates or updates user settings for a current user
     * @return When the user settings have been successfully re-created
     */
    putUserSettings(body: UserSettingsRequestDto, cancelToken?: CancelToken | undefined): Promise<UserSettingsResponseDto> {
        let url_ = this.baseUrl + "/api/v7/users/current/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutUserSettings(_response);
        });
    }

    protected processPutUserSettings(response: AxiosResponse): Promise<UserSettingsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = UserSettingsResponseDto.fromJS(resultData201);
            return Promise.resolve<UserSettingsResponseDto>(result201);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("When the user settings have been updated successfully", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("When error occurs with user settings request data", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSettingsResponseDto>(null as any);
    }

    /**
     * Retrieves filtered Sauen collection
     * @param body (optional) 
     * @return In case proper configuration is updated
     */
    putWokflowConfigurations(body: WorkflowConfigurationRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v7/workflowConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutWokflowConfigurations(_response);
        });
    }

    protected processPutWokflowConfigurations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("In case of invalid parameters", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the Bearer token isn\'t specified or invalid", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("In case the user doesn\'t have permissions to resource", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BuchtDto implements IBuchtDto {
    id?: number;
    betriebId?: number;
    funktionenHistory?: BuchtFunktionHistoryDto[] | undefined;
    modifiedAtUtc?: number;

    constructor(data?: IBuchtDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.betriebId = _data["betriebId"];
            if (Array.isArray(_data["funktionenHistory"])) {
                this.funktionenHistory = [] as any;
                for (let item of _data["funktionenHistory"])
                    this.funktionenHistory!.push(BuchtFunktionHistoryDto.fromJS(item));
            }
            this.modifiedAtUtc = _data["modifiedAtUtc"];
        }
    }

    static fromJS(data: any): BuchtDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuchtDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["betriebId"] = this.betriebId;
        if (Array.isArray(this.funktionenHistory)) {
            data["funktionenHistory"] = [];
            for (let item of this.funktionenHistory)
                data["funktionenHistory"].push(item.toJSON());
        }
        data["modifiedAtUtc"] = this.modifiedAtUtc;
        return data;
    }
}

export interface IBuchtDto {
    id?: number;
    betriebId?: number;
    funktionenHistory?: BuchtFunktionHistoryDto[] | undefined;
    modifiedAtUtc?: number;
}

export class BuchtFunktionHistoryDto implements IBuchtFunktionHistoryDto {
    funktionId?: number;
    recordId?: string;
    futter?: BuchtFutterDto;
    kommentare?: BuchtKommentarDto[] | undefined;
    createdAtUtc?: number;

    constructor(data?: IBuchtFunktionHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.funktionId = _data["funktionId"];
            this.recordId = _data["recordId"];
            this.futter = _data["futter"] ? BuchtFutterDto.fromJS(_data["futter"]) : <any>undefined;
            if (Array.isArray(_data["kommentare"])) {
                this.kommentare = [] as any;
                for (let item of _data["kommentare"])
                    this.kommentare!.push(BuchtKommentarDto.fromJS(item));
            }
            this.createdAtUtc = _data["createdAtUtc"];
        }
    }

    static fromJS(data: any): BuchtFunktionHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuchtFunktionHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["funktionId"] = this.funktionId;
        data["recordId"] = this.recordId;
        data["futter"] = this.futter ? this.futter.toJSON() : <any>undefined;
        if (Array.isArray(this.kommentare)) {
            data["kommentare"] = [];
            for (let item of this.kommentare)
                data["kommentare"].push(item.toJSON());
        }
        data["createdAtUtc"] = this.createdAtUtc;
        return data;
    }
}

export interface IBuchtFunktionHistoryDto {
    funktionId?: number;
    recordId?: string;
    futter?: BuchtFutterDto;
    kommentare?: BuchtKommentarDto[] | undefined;
    createdAtUtc?: number;
}

export class BuchtFutterDto implements IBuchtFutterDto {
    gewicht?: number;
    fuetterungsdatum?: number;

    constructor(data?: IBuchtFutterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gewicht = _data["gewicht"];
            this.fuetterungsdatum = _data["fuetterungsdatum"];
        }
    }

    static fromJS(data: any): BuchtFutterDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuchtFutterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gewicht"] = this.gewicht;
        data["fuetterungsdatum"] = this.fuetterungsdatum;
        return data;
    }
}

export interface IBuchtFutterDto {
    gewicht?: number;
    fuetterungsdatum?: number;
}

export class BuchtKommentarDto implements IBuchtKommentarDto {
    kommentarId?: number;
    workflowId?: number;

    constructor(data?: IBuchtKommentarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kommentarId = _data["kommentarId"];
            this.workflowId = _data["workflowId"];
        }
    }

    static fromJS(data: any): BuchtKommentarDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuchtKommentarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kommentarId"] = this.kommentarId;
        data["workflowId"] = this.workflowId;
        return data;
    }
}

export interface IBuchtKommentarDto {
    kommentarId?: number;
    workflowId?: number;
}

export class BuchtenResponseDto implements IBuchtenResponseDto {
    buchten?: BuchtDto[] | undefined;

    constructor(data?: IBuchtenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buchten"])) {
                this.buchten = [] as any;
                for (let item of _data["buchten"])
                    this.buchten!.push(BuchtDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BuchtenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuchtenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buchten)) {
            data["buchten"] = [];
            for (let item of this.buchten)
                data["buchten"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBuchtenResponseDto {
    buchten?: BuchtDto[] | undefined;
}

/** A CapturedRecordDto represents the data of several process events for the same RecordId */
export class CapturedRecordDto implements ICapturedRecordDto {
    /** The RecordId value from underlying ProzessEvents */
    recordId?: string;
    /** The Id of the Funktion */
    funktionId?: number;
    /** The timestamp of data capturing */
    timestamp?: number;
    /** Key value pairs containing data, key is the workflowId, data is any */
    data?: { [key: string]: any; } | undefined;
    processingState?: ProcessingState;

    constructor(data?: ICapturedRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordId = _data["recordId"];
            this.funktionId = _data["funktionId"];
            this.timestamp = _data["timestamp"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
            this.processingState = _data["processingState"];
        }
    }

    static fromJS(data: any): CapturedRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CapturedRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordId"] = this.recordId;
        data["funktionId"] = this.funktionId;
        data["timestamp"] = this.timestamp;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        data["processingState"] = this.processingState;
        return data;
    }
}

/** A CapturedRecordDto represents the data of several process events for the same RecordId */
export interface ICapturedRecordDto {
    /** The RecordId value from underlying ProzessEvents */
    recordId?: string;
    /** The Id of the Funktion */
    funktionId?: number;
    /** The timestamp of data capturing */
    timestamp?: number;
    /** Key value pairs containing data, key is the workflowId, data is any */
    data?: { [key: string]: any; } | undefined;
    processingState?: ProcessingState;
}

export class CapturedRecordsByIdsRequestDto implements ICapturedRecordsByIdsRequestDto {
    /** The Ids (GUIDs) to search */
    ids!: string[];

    constructor(data?: ICapturedRecordsByIdsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): CapturedRecordsByIdsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CapturedRecordsByIdsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface ICapturedRecordsByIdsRequestDto {
    /** The Ids (GUIDs) to search */
    ids: string[];
}

/** A CapturedRecordsGroupDto represents the data of several process events for the same RecordsGroupId */
export class CapturedRecordsGroupDto implements ICapturedRecordsGroupDto {
    /** The Id of Records Group */
    recordsGroupId?: string;
    /** The Id of the Funktion */
    funktionId?: number;
    /** The timestamp of data capturing */
    timestamp?: number;
    /** Key value pairs containing data, key is the workflowId, data is any */
    data?: { [key: string]: any; } | undefined;
    processingState?: ProcessingState;
    capturedRecords?: CapturedRecordDto[] | undefined;

    constructor(data?: ICapturedRecordsGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsGroupId = _data["recordsGroupId"];
            this.funktionId = _data["funktionId"];
            this.timestamp = _data["timestamp"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
            this.processingState = _data["processingState"];
            if (Array.isArray(_data["capturedRecords"])) {
                this.capturedRecords = [] as any;
                for (let item of _data["capturedRecords"])
                    this.capturedRecords!.push(CapturedRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CapturedRecordsGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CapturedRecordsGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsGroupId"] = this.recordsGroupId;
        data["funktionId"] = this.funktionId;
        data["timestamp"] = this.timestamp;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        data["processingState"] = this.processingState;
        if (Array.isArray(this.capturedRecords)) {
            data["capturedRecords"] = [];
            for (let item of this.capturedRecords)
                data["capturedRecords"].push(item.toJSON());
        }
        return data;
    }
}

/** A CapturedRecordsGroupDto represents the data of several process events for the same RecordsGroupId */
export interface ICapturedRecordsGroupDto {
    /** The Id of Records Group */
    recordsGroupId?: string;
    /** The Id of the Funktion */
    funktionId?: number;
    /** The timestamp of data capturing */
    timestamp?: number;
    /** Key value pairs containing data, key is the workflowId, data is any */
    data?: { [key: string]: any; } | undefined;
    processingState?: ProcessingState;
    capturedRecords?: CapturedRecordDto[] | undefined;
}

export class CapturedRecordsGroupsRequestDto implements ICapturedRecordsGroupsRequestDto {
    /** The Id of the Funktion */
    funktionId!: number;
    /** The Offset for querying the data */
    offset!: number;
    /** The Limit for querying the data */
    limit!: number;
    /** RecordsGroupIds to be removed from the result set */
    skipRecordsGroupIds?: string[] | undefined;

    constructor(data?: ICapturedRecordsGroupsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.funktionId = _data["funktionId"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
            if (Array.isArray(_data["skipRecordsGroupIds"])) {
                this.skipRecordsGroupIds = [] as any;
                for (let item of _data["skipRecordsGroupIds"])
                    this.skipRecordsGroupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CapturedRecordsGroupsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CapturedRecordsGroupsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["funktionId"] = this.funktionId;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        if (Array.isArray(this.skipRecordsGroupIds)) {
            data["skipRecordsGroupIds"] = [];
            for (let item of this.skipRecordsGroupIds)
                data["skipRecordsGroupIds"].push(item);
        }
        return data;
    }
}

export interface ICapturedRecordsGroupsRequestDto {
    /** The Id of the Funktion */
    funktionId: number;
    /** The Offset for querying the data */
    offset: number;
    /** The Limit for querying the data */
    limit: number;
    /** RecordsGroupIds to be removed from the result set */
    skipRecordsGroupIds?: string[] | undefined;
}

export class CapturedRecordsGroupsResponseDto implements ICapturedRecordsGroupsResponseDto {
    /** Record Groups */
    recordsGroups?: CapturedRecordsGroupDto[] | undefined;
    /** The Offset number */
    offset?: number;
    /** Total number of captured record groups */
    totalCount?: number;

    constructor(data?: ICapturedRecordsGroupsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recordsGroups"])) {
                this.recordsGroups = [] as any;
                for (let item of _data["recordsGroups"])
                    this.recordsGroups!.push(CapturedRecordsGroupDto.fromJS(item));
            }
            this.offset = _data["offset"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CapturedRecordsGroupsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CapturedRecordsGroupsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recordsGroups)) {
            data["recordsGroups"] = [];
            for (let item of this.recordsGroups)
                data["recordsGroups"].push(item.toJSON());
        }
        data["offset"] = this.offset;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICapturedRecordsGroupsResponseDto {
    /** Record Groups */
    recordsGroups?: CapturedRecordsGroupDto[] | undefined;
    /** The Offset number */
    offset?: number;
    /** Total number of captured record groups */
    totalCount?: number;
}

export class CapturedRecordsResponseDto implements ICapturedRecordsResponseDto {
    /** Captured Records */
    records?: CapturedRecordDto[] | undefined;
    /** The Offset number */
    offset?: number;
    /** Total number of captured records */
    totalCount?: number;

    constructor(data?: ICapturedRecordsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(CapturedRecordDto.fromJS(item));
            }
            this.offset = _data["offset"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CapturedRecordsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CapturedRecordsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["offset"] = this.offset;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ICapturedRecordsResponseDto {
    /** Captured Records */
    records?: CapturedRecordDto[] | undefined;
    /** The Offset number */
    offset?: number;
    /** Total number of captured records */
    totalCount?: number;
}

export class DataOverviewDto implements IDataOverviewDto {
    headers?: string[] | undefined;
    rows?: string[][] | undefined;

    constructor(data?: IDataOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headers"])) {
                this.headers = [] as any;
                for (let item of _data["headers"])
                    this.headers!.push(item);
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
        }
    }

    static fromJS(data: any): DataOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item);
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        return data;
    }
}

export interface IDataOverviewDto {
    headers?: string[] | undefined;
    rows?: string[][] | undefined;
}

export class DatenimportRowValidationResult implements IDatenimportRowValidationResult {
    rowNumber?: number;
    rowData?: string | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IDatenimportRowValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            this.rowData = _data["rowData"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): DatenimportRowValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new DatenimportRowValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        data["rowData"] = this.rowData;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IDatenimportRowValidationResult {
    rowNumber?: number;
    rowData?: string | undefined;
    errorMessage?: string | undefined;
}

export class DeleteProzessEventsByRecordRequestDto implements IDeleteProzessEventsByRecordRequestDto {
    funktionId!: number;
    recordId!: string;

    constructor(data?: IDeleteProzessEventsByRecordRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.funktionId = _data["funktionId"];
            this.recordId = _data["recordId"];
        }
    }

    static fromJS(data: any): DeleteProzessEventsByRecordRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProzessEventsByRecordRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["funktionId"] = this.funktionId;
        data["recordId"] = this.recordId;
        return data;
    }
}

export interface IDeleteProzessEventsByRecordRequestDto {
    funktionId: number;
    recordId: string;
}

export class DeleteProzessEventsByRecordsGroupRequestDto implements IDeleteProzessEventsByRecordsGroupRequestDto {
    funktionId!: number;
    recordsGroupId!: string;

    constructor(data?: IDeleteProzessEventsByRecordsGroupRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.funktionId = _data["funktionId"];
            this.recordsGroupId = _data["recordsGroupId"];
        }
    }

    static fromJS(data: any): DeleteProzessEventsByRecordsGroupRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProzessEventsByRecordsGroupRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["funktionId"] = this.funktionId;
        data["recordsGroupId"] = this.recordsGroupId;
        return data;
    }
}

export interface IDeleteProzessEventsByRecordsGroupRequestDto {
    funktionId: number;
    recordsGroupId: string;
}

export class DeviceResponseDto implements IDeviceResponseDto {
    deviceId?: string | undefined;

    constructor(data?: IDeviceResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
        }
    }

    static fromJS(data: any): DeviceResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        return data;
    }
}

export interface IDeviceResponseDto {
    deviceId?: string | undefined;
}

export enum EventCategory {
    Undefined = "Undefined",
    None = "None",
    Sau = "Sau",
    Ferkel = "Ferkel",
    Export = "Export",
    Datenimport = "Datenimport",
    Bucht = "Bucht",
    VerkaufCancellationAction = "VerkaufCancellationAction",
}

/** Represents a Ferkel (piglet) */
export class FerkelDto implements IFerkelDto {
    id?: number;
    creationRecordId?: string;
    /** The visual ear tag of a piglet */
    tierIdent?: string | undefined;
    /** The transponder number of an ear tag transponder */
    transponder?: number | undefined;
    genetischeSauDescriptor?: SauLifeStageDescriptorDto;
    buchtsauDescriptor?: SauLifeStageDescriptorDto;
    geschlecht?: Geschlecht;
    createdAtUtc?: number;
    modifiedAtUtc?: number;
    /** List containing all Funktion history entries */
    funktionenHistory?: FerkelFunktionHistoryDto[] | undefined;
    geburtsgewicht?: number;
    /** Indicates the reason for the loss */
    verlustgrund?: number | undefined;
    verkaufsdatum?: number | undefined;
    totgeburt?: number | undefined;

    constructor(data?: IFerkelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationRecordId = _data["creationRecordId"];
            this.tierIdent = _data["tierIdent"];
            this.transponder = _data["transponder"];
            this.genetischeSauDescriptor = _data["genetischeSauDescriptor"] ? SauLifeStageDescriptorDto.fromJS(_data["genetischeSauDescriptor"]) : <any>undefined;
            this.buchtsauDescriptor = _data["buchtsauDescriptor"] ? SauLifeStageDescriptorDto.fromJS(_data["buchtsauDescriptor"]) : <any>undefined;
            this.geschlecht = _data["geschlecht"];
            this.createdAtUtc = _data["createdAtUtc"];
            this.modifiedAtUtc = _data["modifiedAtUtc"];
            if (Array.isArray(_data["funktionenHistory"])) {
                this.funktionenHistory = [] as any;
                for (let item of _data["funktionenHistory"])
                    this.funktionenHistory!.push(FerkelFunktionHistoryDto.fromJS(item));
            }
            this.geburtsgewicht = _data["geburtsgewicht"];
            this.verlustgrund = _data["verlustgrund"];
            this.verkaufsdatum = _data["verkaufsdatum"];
            this.totgeburt = _data["totgeburt"];
        }
    }

    static fromJS(data: any): FerkelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FerkelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationRecordId"] = this.creationRecordId;
        data["tierIdent"] = this.tierIdent;
        data["transponder"] = this.transponder;
        data["genetischeSauDescriptor"] = this.genetischeSauDescriptor ? this.genetischeSauDescriptor.toJSON() : <any>undefined;
        data["buchtsauDescriptor"] = this.buchtsauDescriptor ? this.buchtsauDescriptor.toJSON() : <any>undefined;
        data["geschlecht"] = this.geschlecht;
        data["createdAtUtc"] = this.createdAtUtc;
        data["modifiedAtUtc"] = this.modifiedAtUtc;
        if (Array.isArray(this.funktionenHistory)) {
            data["funktionenHistory"] = [];
            for (let item of this.funktionenHistory)
                data["funktionenHistory"].push(item.toJSON());
        }
        data["geburtsgewicht"] = this.geburtsgewicht;
        data["verlustgrund"] = this.verlustgrund;
        data["verkaufsdatum"] = this.verkaufsdatum;
        data["totgeburt"] = this.totgeburt;
        return data;
    }
}

/** Represents a Ferkel (piglet) */
export interface IFerkelDto {
    id?: number;
    creationRecordId?: string;
    /** The visual ear tag of a piglet */
    tierIdent?: string | undefined;
    /** The transponder number of an ear tag transponder */
    transponder?: number | undefined;
    genetischeSauDescriptor?: SauLifeStageDescriptorDto;
    buchtsauDescriptor?: SauLifeStageDescriptorDto;
    geschlecht?: Geschlecht;
    createdAtUtc?: number;
    modifiedAtUtc?: number;
    /** List containing all Funktion history entries */
    funktionenHistory?: FerkelFunktionHistoryDto[] | undefined;
    geburtsgewicht?: number;
    /** Indicates the reason for the loss */
    verlustgrund?: number | undefined;
    verkaufsdatum?: number | undefined;
    totgeburt?: number | undefined;
}

export class FerkelFunktionHistoryDto implements IFerkelFunktionHistoryDto {
    funktionId?: number;
    /** RecordId of the related ProzessEvents */
    recordId?: string;
    verkaufsdatum?: number | undefined;
    kommentare?: KommentarDto[] | undefined;

    constructor(data?: IFerkelFunktionHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.funktionId = _data["funktionId"];
            this.recordId = _data["recordId"];
            this.verkaufsdatum = _data["verkaufsdatum"];
            if (Array.isArray(_data["kommentare"])) {
                this.kommentare = [] as any;
                for (let item of _data["kommentare"])
                    this.kommentare!.push(KommentarDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FerkelFunktionHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FerkelFunktionHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["funktionId"] = this.funktionId;
        data["recordId"] = this.recordId;
        data["verkaufsdatum"] = this.verkaufsdatum;
        if (Array.isArray(this.kommentare)) {
            data["kommentare"] = [];
            for (let item of this.kommentare)
                data["kommentare"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFerkelFunktionHistoryDto {
    funktionId?: number;
    /** RecordId of the related ProzessEvents */
    recordId?: string;
    verkaufsdatum?: number | undefined;
    kommentare?: KommentarDto[] | undefined;
}

export class FerkelResponseDto implements IFerkelResponseDto {
    ferkel?: FerkelDto[] | undefined;

    constructor(data?: IFerkelResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ferkel"])) {
                this.ferkel = [] as any;
                for (let item of _data["ferkel"])
                    this.ferkel!.push(FerkelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FerkelResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FerkelResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ferkel)) {
            data["ferkel"] = [];
            for (let item of this.ferkel)
                data["ferkel"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFerkelResponseDto {
    ferkel?: FerkelDto[] | undefined;
}

export class FieldFilterDto implements IFieldFilterDto {
    operator?: string | undefined;
    value?: any | undefined;

    constructor(data?: IFieldFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operator = _data["operator"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FieldFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new FieldFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator;
        data["value"] = this.value;
        return data;
    }
}

export interface IFieldFilterDto {
    operator?: string | undefined;
    value?: any | undefined;
}

export class FilterDto implements IFilterDto {
    fieldName?: string | undefined;
    fieldFilters?: FieldFilterDto[] | undefined;

    constructor(data?: IFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            if (Array.isArray(_data["fieldFilters"])) {
                this.fieldFilters = [] as any;
                for (let item of _data["fieldFilters"])
                    this.fieldFilters!.push(FieldFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        if (Array.isArray(this.fieldFilters)) {
            data["fieldFilters"] = [];
            for (let item of this.fieldFilters)
                data["fieldFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterDto {
    fieldName?: string | undefined;
    fieldFilters?: FieldFilterDto[] | undefined;
}

/** The configuration parameters of a Funktion */
export class FunktionConfigurationDto implements IFunktionConfigurationDto {
    /** Number of gestation days */
    traechtigkeitstage?: number;
    /** Duration of buffer time in days */
    pufferzeit?: number;
    /** Duration of lactation in days */
    saeugezeit?: number;
    /** Number of minutes till the deletion of the ProzessEvent isn't possible anymore */
    maxMinutesDeletable?: number;
    /** Specifies the behavior to generate TierIdent on Totgeburt */
    shouldGenerateTierIdentOnTotgeburt?: boolean;
    isReadOnly?: boolean;
    isOnlineOnly?: boolean;
    /** Configuration parameters for the number of records stored in the frontend */
    maxCapturedRecordsAmount?: number;
    /** The button name of save functionality */
    saveButtonName?: string | undefined;
    /** The button icon of save functionality */
    saveButtonIcon?: string | undefined;
    /** Specifies the behavior to use synchronous endpoint for ProzessEvents */
    shouldCallSynchronousProzessEventsProcessing?: boolean;
    /** Specifies the behavior to use show Plan for Ferkels */
    shouldUseFerkelPlan?: boolean;
    /** Specifies the behavior to allow create multiple ProzessEvents */
    allowCreateMultipleProzessEvents?: boolean;

    constructor(data?: IFunktionConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.traechtigkeitstage = _data["traechtigkeitstage"];
            this.pufferzeit = _data["pufferzeit"];
            this.saeugezeit = _data["saeugezeit"];
            this.maxMinutesDeletable = _data["maxMinutesDeletable"];
            this.shouldGenerateTierIdentOnTotgeburt = _data["shouldGenerateTierIdentOnTotgeburt"];
            this.isReadOnly = _data["isReadOnly"];
            this.isOnlineOnly = _data["isOnlineOnly"];
            this.maxCapturedRecordsAmount = _data["maxCapturedRecordsAmount"];
            this.saveButtonName = _data["saveButtonName"];
            this.saveButtonIcon = _data["saveButtonIcon"];
            this.shouldCallSynchronousProzessEventsProcessing = _data["shouldCallSynchronousProzessEventsProcessing"];
            this.shouldUseFerkelPlan = _data["shouldUseFerkelPlan"];
            this.allowCreateMultipleProzessEvents = _data["allowCreateMultipleProzessEvents"];
        }
    }

    static fromJS(data: any): FunktionConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FunktionConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["traechtigkeitstage"] = this.traechtigkeitstage;
        data["pufferzeit"] = this.pufferzeit;
        data["saeugezeit"] = this.saeugezeit;
        data["maxMinutesDeletable"] = this.maxMinutesDeletable;
        data["shouldGenerateTierIdentOnTotgeburt"] = this.shouldGenerateTierIdentOnTotgeburt;
        data["isReadOnly"] = this.isReadOnly;
        data["isOnlineOnly"] = this.isOnlineOnly;
        data["maxCapturedRecordsAmount"] = this.maxCapturedRecordsAmount;
        data["saveButtonName"] = this.saveButtonName;
        data["saveButtonIcon"] = this.saveButtonIcon;
        data["shouldCallSynchronousProzessEventsProcessing"] = this.shouldCallSynchronousProzessEventsProcessing;
        data["shouldUseFerkelPlan"] = this.shouldUseFerkelPlan;
        data["allowCreateMultipleProzessEvents"] = this.allowCreateMultipleProzessEvents;
        return data;
    }
}

/** The configuration parameters of a Funktion */
export interface IFunktionConfigurationDto {
    /** Number of gestation days */
    traechtigkeitstage?: number;
    /** Duration of buffer time in days */
    pufferzeit?: number;
    /** Duration of lactation in days */
    saeugezeit?: number;
    /** Number of minutes till the deletion of the ProzessEvent isn't possible anymore */
    maxMinutesDeletable?: number;
    /** Specifies the behavior to generate TierIdent on Totgeburt */
    shouldGenerateTierIdentOnTotgeburt?: boolean;
    isReadOnly?: boolean;
    isOnlineOnly?: boolean;
    /** Configuration parameters for the number of records stored in the frontend */
    maxCapturedRecordsAmount?: number;
    /** The button name of save functionality */
    saveButtonName?: string | undefined;
    /** The button icon of save functionality */
    saveButtonIcon?: string | undefined;
    /** Specifies the behavior to use synchronous endpoint for ProzessEvents */
    shouldCallSynchronousProzessEventsProcessing?: boolean;
    /** Specifies the behavior to use show Plan for Ferkels */
    shouldUseFerkelPlan?: boolean;
    /** Specifies the behavior to allow create multiple ProzessEvents */
    allowCreateMultipleProzessEvents?: boolean;
}

/** A unit that enables existing Prozesse to be combined into one Funktion in a customer-specific way */
export class FunktionDto implements IFunktionDto {
    /** A unique id of a Funktion */
    id?: number;
    /** The designation of a Funktion, e.g.: "P1 - Ersterfassung" */
    name?: string | undefined;
    /** The name of the icon */
    icon?: string | undefined;
    /** List of available Prozesse */
    prozesse?: ProzessDto[] | undefined;
    funktionConfiguration?: FunktionConfigurationDto;
    /** Configuration parameter for the display order of the function (e.g. in the menu) */
    displayOrder?: number;
    /** Specifies the highlight color of a function */
    color?: string | undefined;
    /** Contains data filters for the underlying Prozesse collection */
    prozessDataFilters?: ProzessDataFilterDto[] | undefined;
    /** Funktion description from db */
    description?: string | undefined;

    constructor(data?: IFunktionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            if (Array.isArray(_data["prozesse"])) {
                this.prozesse = [] as any;
                for (let item of _data["prozesse"])
                    this.prozesse!.push(ProzessDto.fromJS(item));
            }
            this.funktionConfiguration = _data["funktionConfiguration"] ? FunktionConfigurationDto.fromJS(_data["funktionConfiguration"]) : <any>undefined;
            this.displayOrder = _data["displayOrder"];
            this.color = _data["color"];
            if (Array.isArray(_data["prozessDataFilters"])) {
                this.prozessDataFilters = [] as any;
                for (let item of _data["prozessDataFilters"])
                    this.prozessDataFilters!.push(ProzessDataFilterDto.fromJS(item));
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FunktionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FunktionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        if (Array.isArray(this.prozesse)) {
            data["prozesse"] = [];
            for (let item of this.prozesse)
                data["prozesse"].push(item.toJSON());
        }
        data["funktionConfiguration"] = this.funktionConfiguration ? this.funktionConfiguration.toJSON() : <any>undefined;
        data["displayOrder"] = this.displayOrder;
        data["color"] = this.color;
        if (Array.isArray(this.prozessDataFilters)) {
            data["prozessDataFilters"] = [];
            for (let item of this.prozessDataFilters)
                data["prozessDataFilters"].push(item.toJSON());
        }
        data["description"] = this.description;
        return data;
    }
}

/** A unit that enables existing Prozesse to be combined into one Funktion in a customer-specific way */
export interface IFunktionDto {
    /** A unique id of a Funktion */
    id?: number;
    /** The designation of a Funktion, e.g.: "P1 - Ersterfassung" */
    name?: string | undefined;
    /** The name of the icon */
    icon?: string | undefined;
    /** List of available Prozesse */
    prozesse?: ProzessDto[] | undefined;
    funktionConfiguration?: FunktionConfigurationDto;
    /** Configuration parameter for the display order of the function (e.g. in the menu) */
    displayOrder?: number;
    /** Specifies the highlight color of a function */
    color?: string | undefined;
    /** Contains data filters for the underlying Prozesse collection */
    prozessDataFilters?: ProzessDataFilterDto[] | undefined;
    /** Funktion description from db */
    description?: string | undefined;
}

export class FunktionTrimmedDto implements IFunktionTrimmedDto {
    id?: number;
    name?: string | undefined;
    prozesse?: ProzessTrimmedDto[] | undefined;
    displayOrder?: number;

    constructor(data?: IFunktionTrimmedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["prozesse"])) {
                this.prozesse = [] as any;
                for (let item of _data["prozesse"])
                    this.prozesse!.push(ProzessTrimmedDto.fromJS(item));
            }
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): FunktionTrimmedDto {
        data = typeof data === 'object' ? data : {};
        let result = new FunktionTrimmedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.prozesse)) {
            data["prozesse"] = [];
            for (let item of this.prozesse)
                data["prozesse"].push(item.toJSON());
        }
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IFunktionTrimmedDto {
    id?: number;
    name?: string | undefined;
    prozesse?: ProzessTrimmedDto[] | undefined;
    displayOrder?: number;
}

export class FunktionenResponseDto implements IFunktionenResponseDto {
    funktionen?: FunktionDto[] | undefined;

    constructor(data?: IFunktionenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["funktionen"])) {
                this.funktionen = [] as any;
                for (let item of _data["funktionen"])
                    this.funktionen!.push(FunktionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FunktionenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FunktionenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.funktionen)) {
            data["funktionen"] = [];
            for (let item of this.funktionen)
                data["funktionen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFunktionenResponseDto {
    funktionen?: FunktionDto[] | undefined;
}

export enum Geschlecht {
    Eber = "Eber",
    Sau = "Sau",
    Kastrat = "Kastrat",
}

export class KeyValueDto implements IKeyValueDto {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IKeyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValueDto {
    key?: string | undefined;
    value?: string | undefined;
}

export class KommentarDto implements IKommentarDto {
    workflowId?: number;
    id?: number;
    name?: string | undefined;

    constructor(data?: IKommentarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowId = _data["workflowId"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): KommentarDto {
        data = typeof data === 'object' ? data : {};
        let result = new KommentarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowId"] = this.workflowId;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IKommentarDto {
    workflowId?: number;
    id?: number;
    name?: string | undefined;
}

export class LoginRequestDto implements ILoginRequestDto {
    /** Username, for employees consisting of Company.Id-DisplayName */
    username!: string;
    /** Password */
    password!: string;

    constructor(data?: ILoginRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginRequestDto {
    /** Username, for employees consisting of Company.Id-DisplayName */
    username: string;
    /** Password */
    password: string;
}

export class PlanFerkelDto implements IPlanFerkelDto {
    buchtId?: number;
    transponder?: number;
    geschlecht?: Geschlecht;
    keyValuesInfo?: KeyValueDto[] | undefined;

    constructor(data?: IPlanFerkelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buchtId = _data["buchtId"];
            this.transponder = _data["transponder"];
            this.geschlecht = _data["geschlecht"];
            if (Array.isArray(_data["keyValuesInfo"])) {
                this.keyValuesInfo = [] as any;
                for (let item of _data["keyValuesInfo"])
                    this.keyValuesInfo!.push(KeyValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlanFerkelDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanFerkelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buchtId"] = this.buchtId;
        data["transponder"] = this.transponder;
        data["geschlecht"] = this.geschlecht;
        if (Array.isArray(this.keyValuesInfo)) {
            data["keyValuesInfo"] = [];
            for (let item of this.keyValuesInfo)
                data["keyValuesInfo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlanFerkelDto {
    buchtId?: number;
    transponder?: number;
    geschlecht?: Geschlecht;
    keyValuesInfo?: KeyValueDto[] | undefined;
}

export class PlanFerkelResponseDto implements IPlanFerkelResponseDto {
    planFerkel?: PlanFerkelDto[] | undefined;

    constructor(data?: IPlanFerkelResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["planFerkel"])) {
                this.planFerkel = [] as any;
                for (let item of _data["planFerkel"])
                    this.planFerkel!.push(PlanFerkelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlanFerkelResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanFerkelResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.planFerkel)) {
            data["planFerkel"] = [];
            for (let item of this.planFerkel)
                data["planFerkel"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlanFerkelResponseDto {
    planFerkel?: PlanFerkelDto[] | undefined;
}

export class ProblemReportDto implements IProblemReportDto {
    id!: string;
    userName!: string;
    deviceId!: string;
    appVersion!: string;
    reportMessage?: string | undefined;
    exportedData!: string;

    constructor(data?: IProblemReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.deviceId = _data["deviceId"];
            this.appVersion = _data["appVersion"];
            this.reportMessage = _data["reportMessage"];
            this.exportedData = _data["exportedData"];
        }
    }

    static fromJS(data: any): ProblemReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["deviceId"] = this.deviceId;
        data["appVersion"] = this.appVersion;
        data["reportMessage"] = this.reportMessage;
        data["exportedData"] = this.exportedData;
        return data;
    }
}

export interface IProblemReportDto {
    id: string;
    userName: string;
    deviceId: string;
    appVersion: string;
    reportMessage?: string | undefined;
    exportedData: string;
}

export enum ProcessingState {
    New = "New",
    Processed = "Processed",
    Failed = "Failed",
    Skipped = "Skipped",
    Deleted = "Deleted",
    Ignored = "Ignored",
    Overwritten = "Overwritten",
    Reverted = "Reverted",
}

export class ProzessDataDto implements IProzessDataDto {
    id?: any | undefined;
    label?: string | undefined;
    value?: string | undefined;
    additional?: { [key: string]: any; } | undefined;

    constructor(data?: IProzessDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.value = _data["value"];
            if (_data["additional"]) {
                this.additional = {} as any;
                for (let key in _data["additional"]) {
                    if (_data["additional"].hasOwnProperty(key))
                        (<any>this.additional)![key] = _data["additional"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProzessDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProzessDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["value"] = this.value;
        if (this.additional) {
            data["additional"] = {};
            for (let key in this.additional) {
                if (this.additional.hasOwnProperty(key))
                    (<any>data["additional"])[key] = (<any>this.additional)[key];
            }
        }
        return data;
    }
}

export interface IProzessDataDto {
    id?: any | undefined;
    label?: string | undefined;
    value?: string | undefined;
    additional?: { [key: string]: any; } | undefined;
}

export class ProzessDataFilterDto implements IProzessDataFilterDto {
    type?: string | undefined;
    filters?: FilterDto[] | undefined;

    constructor(data?: IProzessDataFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProzessDataFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProzessDataFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProzessDataFilterDto {
    type?: string | undefined;
    filters?: FilterDto[] | undefined;
}

/** A Prozess is a reusable entity and is used for data collection, entry, and record coordination. */
export class ProzessDto implements IProzessDto {
    /** The Unique Id of the Prozess (WorkflowId from backend) */
    workflowId?: number;
    prozessType?: ProzessType;
    /** The label of a Prozess to display */
    label?: string | undefined;
    /** Represents a postfix of the control's value */
    valuePostfix?: string | undefined;
    validMinValue?: number;
    validMaxValue?: number;
    optimalMinValue?: number;
    optimalMaxValue?: number;
    /** A regex pattern encoded in base64 to validate the Control value */
    validationPattern?: string | undefined;
    /** The type of control used */
    controlType?: string | undefined;
    eventCategory?: EventCategory;
    /** The type of event to be raised by this Prozess */
    eventType?: string | undefined;
    /** The type of event to be raised by this Prozess when there is manual input */
    manualEventType?: string | undefined;
    /** The type of event to be raised by this Prozess when a value changes */
    changeEventType?: string | undefined;
    /** The type of event to be raised by this Prozess when a value is manually changed */
    changeManualEventType?: string | undefined;
    /** The data available for this Prozess */
    data?: ProzessDataDto[] | undefined;
    metadata?: ProzessMetadataDto;
    /** The positioning of the Prozess on the surface */
    position?: string | undefined;
    /** Indication of whether the Prozess is a mandatory entry within a specific function */
    isRequired?: boolean;
    /** Indicates whether the Prozess requires a Bluetooth connection to the IQ Hub */
    isBluetoothRequired?: boolean;
    /** Specifies the behavior to keep the value after saving */
    shouldKeepValue?: boolean;
    /** Indicates the possibility of using a default value instead of nothing */
    shouldUsePreselectedValue?: boolean;
    /** Indicates the behavior to disable the Workflow if some data is already used */
    shouldBeDisabledWhenReceivedFirstValue?: boolean;
    /** Indicates whether the selection of multiple values is allowed */
    isMultipleSelectionAllowed?: boolean;
    /** Indicates whether the data collected by the Prozess should be displayed in the Last Records table */
    shouldShowCreatedRecords?: boolean;
    /** Indicates whether the data should appear in TierInfo details for Piglets */
    shouldShowInTierInfoDetails?: boolean;
    /** Indicates the position of a Prozess within the RecordsTable */
    recordsDisplayOrder?: number;
    /** Indicates whether the data displayed by the Prozess depends on the selection in another Prozess (by WorkflowId) */
    filteredByWorkflowId?: number | undefined;
    /** Specifies whether to react to changes from another Prozess (by WorkflowId) */
    shouldListenForChangesOnWorkflowId?: number | undefined;
    /** Specifies whether the difference between the selected value and another Prozess (by WorkflowId) should be highlighted graphically */
    shouldHighlightDifferenceToWorkflowId?: number | undefined;
    /** Indicates whether the change of the selected value should be explicitly confirmed */
    isAskingForChangesConfirmation?: boolean;
    /** Indicates if the same value (e.g. TierIdent) can be used multiple times within the same function */
    shouldAllowMultipleUsage?: boolean;
    /** Represents the behavior to create many Prozess Events by one Prozess */
    shouldCreateMultipleProzessEvents?: boolean;
    /** Indicates the possibility to change an already captured value, i.e. the possibility to use Change Events */
    isEditable?: boolean;
    gewichtMaxDifference?: number;
    gewichtAverageCount?: number;
    skipNumberOfValidGewichtValues?: number;
    isReadOnly?: boolean;
    dataExportConfigurationId?: number;
    shouldFixLeftColumn?: boolean;
    shouldFixHeader?: boolean;
    shouldPreselectNextValue?: boolean;
    shouldAutoSaveOnScan?: boolean;
    /** Indicates whether the Prozess should ignore Bluetooth data */
    hasToIgnoreBluetoothData?: boolean;

    constructor(data?: IProzessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowId = _data["workflowId"];
            this.prozessType = _data["prozessType"];
            this.label = _data["label"];
            this.valuePostfix = _data["valuePostfix"];
            this.validMinValue = _data["validMinValue"];
            this.validMaxValue = _data["validMaxValue"];
            this.optimalMinValue = _data["optimalMinValue"];
            this.optimalMaxValue = _data["optimalMaxValue"];
            this.validationPattern = _data["validationPattern"];
            this.controlType = _data["controlType"];
            this.eventCategory = _data["eventCategory"];
            this.eventType = _data["eventType"];
            this.manualEventType = _data["manualEventType"];
            this.changeEventType = _data["changeEventType"];
            this.changeManualEventType = _data["changeManualEventType"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProzessDataDto.fromJS(item));
            }
            this.metadata = _data["metadata"] ? ProzessMetadataDto.fromJS(_data["metadata"]) : <any>undefined;
            this.position = _data["position"];
            this.isRequired = _data["isRequired"];
            this.isBluetoothRequired = _data["isBluetoothRequired"];
            this.shouldKeepValue = _data["shouldKeepValue"];
            this.shouldUsePreselectedValue = _data["shouldUsePreselectedValue"];
            this.shouldBeDisabledWhenReceivedFirstValue = _data["shouldBeDisabledWhenReceivedFirstValue"];
            this.isMultipleSelectionAllowed = _data["isMultipleSelectionAllowed"];
            this.shouldShowCreatedRecords = _data["shouldShowCreatedRecords"];
            this.shouldShowInTierInfoDetails = _data["shouldShowInTierInfoDetails"];
            this.recordsDisplayOrder = _data["recordsDisplayOrder"];
            this.filteredByWorkflowId = _data["filteredByWorkflowId"];
            this.shouldListenForChangesOnWorkflowId = _data["shouldListenForChangesOnWorkflowId"];
            this.shouldHighlightDifferenceToWorkflowId = _data["shouldHighlightDifferenceToWorkflowId"];
            this.isAskingForChangesConfirmation = _data["isAskingForChangesConfirmation"];
            this.shouldAllowMultipleUsage = _data["shouldAllowMultipleUsage"];
            this.shouldCreateMultipleProzessEvents = _data["shouldCreateMultipleProzessEvents"];
            this.isEditable = _data["isEditable"];
            this.gewichtMaxDifference = _data["gewichtMaxDifference"];
            this.gewichtAverageCount = _data["gewichtAverageCount"];
            this.skipNumberOfValidGewichtValues = _data["skipNumberOfValidGewichtValues"];
            this.isReadOnly = _data["isReadOnly"];
            this.dataExportConfigurationId = _data["dataExportConfigurationId"];
            this.shouldFixLeftColumn = _data["shouldFixLeftColumn"];
            this.shouldFixHeader = _data["shouldFixHeader"];
            this.shouldPreselectNextValue = _data["shouldPreselectNextValue"];
            this.shouldAutoSaveOnScan = _data["shouldAutoSaveOnScan"];
            this.hasToIgnoreBluetoothData = _data["hasToIgnoreBluetoothData"];
        }
    }

    static fromJS(data: any): ProzessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProzessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowId"] = this.workflowId;
        data["prozessType"] = this.prozessType;
        data["label"] = this.label;
        data["valuePostfix"] = this.valuePostfix;
        data["validMinValue"] = this.validMinValue;
        data["validMaxValue"] = this.validMaxValue;
        data["optimalMinValue"] = this.optimalMinValue;
        data["optimalMaxValue"] = this.optimalMaxValue;
        data["validationPattern"] = this.validationPattern;
        data["controlType"] = this.controlType;
        data["eventCategory"] = this.eventCategory;
        data["eventType"] = this.eventType;
        data["manualEventType"] = this.manualEventType;
        data["changeEventType"] = this.changeEventType;
        data["changeManualEventType"] = this.changeManualEventType;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        data["position"] = this.position;
        data["isRequired"] = this.isRequired;
        data["isBluetoothRequired"] = this.isBluetoothRequired;
        data["shouldKeepValue"] = this.shouldKeepValue;
        data["shouldUsePreselectedValue"] = this.shouldUsePreselectedValue;
        data["shouldBeDisabledWhenReceivedFirstValue"] = this.shouldBeDisabledWhenReceivedFirstValue;
        data["isMultipleSelectionAllowed"] = this.isMultipleSelectionAllowed;
        data["shouldShowCreatedRecords"] = this.shouldShowCreatedRecords;
        data["shouldShowInTierInfoDetails"] = this.shouldShowInTierInfoDetails;
        data["recordsDisplayOrder"] = this.recordsDisplayOrder;
        data["filteredByWorkflowId"] = this.filteredByWorkflowId;
        data["shouldListenForChangesOnWorkflowId"] = this.shouldListenForChangesOnWorkflowId;
        data["shouldHighlightDifferenceToWorkflowId"] = this.shouldHighlightDifferenceToWorkflowId;
        data["isAskingForChangesConfirmation"] = this.isAskingForChangesConfirmation;
        data["shouldAllowMultipleUsage"] = this.shouldAllowMultipleUsage;
        data["shouldCreateMultipleProzessEvents"] = this.shouldCreateMultipleProzessEvents;
        data["isEditable"] = this.isEditable;
        data["gewichtMaxDifference"] = this.gewichtMaxDifference;
        data["gewichtAverageCount"] = this.gewichtAverageCount;
        data["skipNumberOfValidGewichtValues"] = this.skipNumberOfValidGewichtValues;
        data["isReadOnly"] = this.isReadOnly;
        data["dataExportConfigurationId"] = this.dataExportConfigurationId;
        data["shouldFixLeftColumn"] = this.shouldFixLeftColumn;
        data["shouldFixHeader"] = this.shouldFixHeader;
        data["shouldPreselectNextValue"] = this.shouldPreselectNextValue;
        data["shouldAutoSaveOnScan"] = this.shouldAutoSaveOnScan;
        data["hasToIgnoreBluetoothData"] = this.hasToIgnoreBluetoothData;
        return data;
    }
}

/** A Prozess is a reusable entity and is used for data collection, entry, and record coordination. */
export interface IProzessDto {
    /** The Unique Id of the Prozess (WorkflowId from backend) */
    workflowId?: number;
    prozessType?: ProzessType;
    /** The label of a Prozess to display */
    label?: string | undefined;
    /** Represents a postfix of the control's value */
    valuePostfix?: string | undefined;
    validMinValue?: number;
    validMaxValue?: number;
    optimalMinValue?: number;
    optimalMaxValue?: number;
    /** A regex pattern encoded in base64 to validate the Control value */
    validationPattern?: string | undefined;
    /** The type of control used */
    controlType?: string | undefined;
    eventCategory?: EventCategory;
    /** The type of event to be raised by this Prozess */
    eventType?: string | undefined;
    /** The type of event to be raised by this Prozess when there is manual input */
    manualEventType?: string | undefined;
    /** The type of event to be raised by this Prozess when a value changes */
    changeEventType?: string | undefined;
    /** The type of event to be raised by this Prozess when a value is manually changed */
    changeManualEventType?: string | undefined;
    /** The data available for this Prozess */
    data?: ProzessDataDto[] | undefined;
    metadata?: ProzessMetadataDto;
    /** The positioning of the Prozess on the surface */
    position?: string | undefined;
    /** Indication of whether the Prozess is a mandatory entry within a specific function */
    isRequired?: boolean;
    /** Indicates whether the Prozess requires a Bluetooth connection to the IQ Hub */
    isBluetoothRequired?: boolean;
    /** Specifies the behavior to keep the value after saving */
    shouldKeepValue?: boolean;
    /** Indicates the possibility of using a default value instead of nothing */
    shouldUsePreselectedValue?: boolean;
    /** Indicates the behavior to disable the Workflow if some data is already used */
    shouldBeDisabledWhenReceivedFirstValue?: boolean;
    /** Indicates whether the selection of multiple values is allowed */
    isMultipleSelectionAllowed?: boolean;
    /** Indicates whether the data collected by the Prozess should be displayed in the Last Records table */
    shouldShowCreatedRecords?: boolean;
    /** Indicates whether the data should appear in TierInfo details for Piglets */
    shouldShowInTierInfoDetails?: boolean;
    /** Indicates the position of a Prozess within the RecordsTable */
    recordsDisplayOrder?: number;
    /** Indicates whether the data displayed by the Prozess depends on the selection in another Prozess (by WorkflowId) */
    filteredByWorkflowId?: number | undefined;
    /** Specifies whether to react to changes from another Prozess (by WorkflowId) */
    shouldListenForChangesOnWorkflowId?: number | undefined;
    /** Specifies whether the difference between the selected value and another Prozess (by WorkflowId) should be highlighted graphically */
    shouldHighlightDifferenceToWorkflowId?: number | undefined;
    /** Indicates whether the change of the selected value should be explicitly confirmed */
    isAskingForChangesConfirmation?: boolean;
    /** Indicates if the same value (e.g. TierIdent) can be used multiple times within the same function */
    shouldAllowMultipleUsage?: boolean;
    /** Represents the behavior to create many Prozess Events by one Prozess */
    shouldCreateMultipleProzessEvents?: boolean;
    /** Indicates the possibility to change an already captured value, i.e. the possibility to use Change Events */
    isEditable?: boolean;
    gewichtMaxDifference?: number;
    gewichtAverageCount?: number;
    skipNumberOfValidGewichtValues?: number;
    isReadOnly?: boolean;
    dataExportConfigurationId?: number;
    shouldFixLeftColumn?: boolean;
    shouldFixHeader?: boolean;
    shouldPreselectNextValue?: boolean;
    shouldAutoSaveOnScan?: boolean;
    /** Indicates whether the Prozess should ignore Bluetooth data */
    hasToIgnoreBluetoothData?: boolean;
}

/** Represents the captured data */
export class ProzessEventDto implements IProzessEventDto {
    /** The unique id of individual ProzessEvent from the client */
    transactionId!: string;
    /** The unique id of the bundle of prozess events which represents single operation */
    recordId!: string;
    /** The unique id of the group of Records which should be processed within a single transaction */
    recordsGroupId!: string;
    eventCategory!: EventCategory;
    /** Timepoint of data capturing (UTC) */
    createdAtUtc!: Date;
    /** The unique Id of the Workflow (in the backend) */
    workflowId!: number;
    /** Die eindeutige Id der Funktion */
    funktionId!: number;
    prozessType!: ProzessType;
    eventType!: string;
    /** The actual data */
    data!: string;
    /** Additional metadata (e.g. version of the IQ-Hubs) */
    metaData?: any | undefined;
    /** The version of the application */
    appVersion?: string | undefined;
    /** The Id of User which created the Event */
    userId!: string;
    processingState?: ProcessingState;

    constructor(data?: IProzessEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.recordId = _data["recordId"];
            this.recordsGroupId = _data["recordsGroupId"];
            this.eventCategory = _data["eventCategory"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>undefined;
            this.workflowId = _data["workflowId"];
            this.funktionId = _data["funktionId"];
            this.prozessType = _data["prozessType"];
            this.eventType = _data["eventType"];
            this.data = _data["data"];
            this.metaData = _data["metaData"];
            this.appVersion = _data["appVersion"];
            this.userId = _data["userId"];
            this.processingState = _data["processingState"];
        }
    }

    static fromJS(data: any): ProzessEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProzessEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["recordId"] = this.recordId;
        data["recordsGroupId"] = this.recordsGroupId;
        data["eventCategory"] = this.eventCategory;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : <any>undefined;
        data["workflowId"] = this.workflowId;
        data["funktionId"] = this.funktionId;
        data["prozessType"] = this.prozessType;
        data["eventType"] = this.eventType;
        data["data"] = this.data;
        data["metaData"] = this.metaData;
        data["appVersion"] = this.appVersion;
        data["userId"] = this.userId;
        data["processingState"] = this.processingState;
        return data;
    }
}

/** Represents the captured data */
export interface IProzessEventDto {
    /** The unique id of individual ProzessEvent from the client */
    transactionId: string;
    /** The unique id of the bundle of prozess events which represents single operation */
    recordId: string;
    /** The unique id of the group of Records which should be processed within a single transaction */
    recordsGroupId: string;
    eventCategory: EventCategory;
    /** Timepoint of data capturing (UTC) */
    createdAtUtc: Date;
    /** The unique Id of the Workflow (in the backend) */
    workflowId: number;
    /** Die eindeutige Id der Funktion */
    funktionId: number;
    prozessType: ProzessType;
    eventType: string;
    /** The actual data */
    data: string;
    /** Additional metadata (e.g. version of the IQ-Hubs) */
    metaData?: any | undefined;
    /** The version of the application */
    appVersion?: string | undefined;
    /** The Id of User which created the Event */
    userId: string;
    processingState?: ProcessingState;
}

/** Provides a request container for the process events */
export class ProzessEventsRequestDto implements IProzessEventsRequestDto {
    /** List of process events */
    prozessEvents!: ProzessEventDto[];

    constructor(data?: IProzessEventsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.prozessEvents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prozessEvents"])) {
                this.prozessEvents = [] as any;
                for (let item of _data["prozessEvents"])
                    this.prozessEvents!.push(ProzessEventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProzessEventsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProzessEventsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prozessEvents)) {
            data["prozessEvents"] = [];
            for (let item of this.prozessEvents)
                data["prozessEvents"].push(item.toJSON());
        }
        return data;
    }
}

/** Provides a request container for the process events */
export interface IProzessEventsRequestDto {
    /** List of process events */
    prozessEvents: ProzessEventDto[];
}

export class ProzessEventsValidationResultDto implements IProzessEventsValidationResultDto {
    generalMessages?: string[] | undefined;
    rowValidationMessages?: DatenimportRowValidationResult[] | undefined;

    constructor(data?: IProzessEventsValidationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["generalMessages"])) {
                this.generalMessages = [] as any;
                for (let item of _data["generalMessages"])
                    this.generalMessages!.push(item);
            }
            if (Array.isArray(_data["rowValidationMessages"])) {
                this.rowValidationMessages = [] as any;
                for (let item of _data["rowValidationMessages"])
                    this.rowValidationMessages!.push(DatenimportRowValidationResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProzessEventsValidationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProzessEventsValidationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.generalMessages)) {
            data["generalMessages"] = [];
            for (let item of this.generalMessages)
                data["generalMessages"].push(item);
        }
        if (Array.isArray(this.rowValidationMessages)) {
            data["rowValidationMessages"] = [];
            for (let item of this.rowValidationMessages)
                data["rowValidationMessages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProzessEventsValidationResultDto {
    generalMessages?: string[] | undefined;
    rowValidationMessages?: DatenimportRowValidationResult[] | undefined;
}

/** Represents a Metadata needed fo specific Prozess to work (e.g. Funktionen information for TIER_INFO prozess type) */
export class ProzessMetadataDto implements IProzessMetadataDto {
    /** This property used by Prozess to get description of each Funktion and each Workflow in it */
    funktionen?: FunktionTrimmedDto[] | undefined;

    constructor(data?: IProzessMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["funktionen"])) {
                this.funktionen = [] as any;
                for (let item of _data["funktionen"])
                    this.funktionen!.push(FunktionTrimmedDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProzessMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProzessMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.funktionen)) {
            data["funktionen"] = [];
            for (let item of this.funktionen)
                data["funktionen"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a Metadata needed fo specific Prozess to work (e.g. Funktionen information for TIER_INFO prozess type) */
export interface IProzessMetadataDto {
    /** This property used by Prozess to get description of each Funktion and each Workflow in it */
    funktionen?: FunktionTrimmedDto[] | undefined;
}

export class ProzessTrimmedDto implements IProzessTrimmedDto {
    workflowId?: number;
    label?: string | undefined;
    shouldShowCreatedRecords?: boolean;
    recordsDisplayOrder?: number;
    shouldShowInTierInfoDetails?: boolean;

    constructor(data?: IProzessTrimmedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowId = _data["workflowId"];
            this.label = _data["label"];
            this.shouldShowCreatedRecords = _data["shouldShowCreatedRecords"];
            this.recordsDisplayOrder = _data["recordsDisplayOrder"];
            this.shouldShowInTierInfoDetails = _data["shouldShowInTierInfoDetails"];
        }
    }

    static fromJS(data: any): ProzessTrimmedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProzessTrimmedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowId"] = this.workflowId;
        data["label"] = this.label;
        data["shouldShowCreatedRecords"] = this.shouldShowCreatedRecords;
        data["recordsDisplayOrder"] = this.recordsDisplayOrder;
        data["shouldShowInTierInfoDetails"] = this.shouldShowInTierInfoDetails;
        return data;
    }
}

export interface IProzessTrimmedDto {
    workflowId?: number;
    label?: string | undefined;
    shouldShowCreatedRecords?: boolean;
    recordsDisplayOrder?: number;
    shouldShowInTierInfoDetails?: boolean;
}

export enum ProzessType {
    GEWICHT = "GEWICHT",
    TRANSPONDER = "TRANSPONDER",
    TIER_IDENT = "TIER_IDENT",
    LAST_RECORDS = "LAST_RECORDS",
    KOMMENTARE = "KOMMENTARE",
    VERLUSTGRUND = "VERLUSTGRUND",
    GESCHLECHT = "GESCHLECHT",
    BUCHTSAU = "BUCHTSAU",
    GENETISCHESAU = "GENETISCHESAU",
    TOTGEBURT = "TOTGEBURT",
    ALL_RECORDS = "ALL_RECORDS",
    WURFUEBERSICHT = "WURFUEBERSICHT",
    FERKEL_ABGESETZT = "FERKEL_ABGESETZT",
    ABFERKELDATUM = "ABFERKELDATUM",
    ABSETZDATUM = "ABSETZDATUM",
    MUMIEN = "MUMIEN",
    VERLUSTDATUM = "VERLUSTDATUM",
    PROZESS_EVENTS_COUNTER = "PROZESS_EVENTS_COUNTER",
    INFO_FERKEL = "INFO_FERKEL",
    INFO_NEUE_BUCHTSAU = "INFO_NEUE_BUCHTSAU",
    EINSTALLDATUM = "EINSTALLDATUM",
    BUCHT = "BUCHT",
    SAU = "SAU",
    RUECKENSPECKDICKE_VORNE = "RUECKENSPECKDICKE_VORNE",
    RUECKENSPECKDICKE_MITTE = "RUECKENSPECKDICKE_MITTE",
    RUECKENSPECKDICKE_HINTEN = "RUECKENSPECKDICKE_HINTEN",
    VERSETZDATUM = "VERSETZDATUM",
    EMAIL = "EMAIL",
    DATUM_VON = "DATUM_VON",
    DATUM_BIS = "DATUM_BIS",
    LAST_EXPORTS = "LAST_EXPORTS",
    FUTTER_GEWICHT = "FUTTER_GEWICHT",
    FUETTERUNGSDATUM = "FUETTERUNGSDATUM",
    TIER_INFO = "TIER_INFO",
    TRANSPONDER_KENNZEICHNUNGSDATUM = "TRANSPONDER_KENNZEICHNUNGSDATUM",
    DATA_EXPORT_TYPE = "DATA_EXPORT_TYPE",
    ALL_EXPORTS = "ALL_EXPORTS",
    VERKAUFSDATUM = "VERKAUFSDATUM",
    INFO_FUTTER = "INFO_FUTTER",
    DATA_OVERVIEW = "DATA_OVERVIEW",
    DATENIMPORT_FORMAT = "DATENIMPORT_FORMAT",
    DATENIMPORT_TEXT_FILE_CONTENT = "DATENIMPORT_TEXT_FILE_CONTENT",
    INFO_PLAN = "INFO_PLAN",
    AMMENDATUM = "AMMENDATUM",
    INFO_VERKAUF = "INFO_VERKAUF",
    SAU_TRANSPONDER = "SAU_TRANSPONDER",
}

export class SauBuchtDto implements ISauBuchtDto {
    id?: number;
    buchtId?: number;
    funktionHistoryId?: number;
    createdAtUtc?: number;
    createdDate?: string | undefined;

    constructor(data?: ISauBuchtDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.buchtId = _data["buchtId"];
            this.funktionHistoryId = _data["funktionHistoryId"];
            this.createdAtUtc = _data["createdAtUtc"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): SauBuchtDto {
        data = typeof data === 'object' ? data : {};
        let result = new SauBuchtDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["buchtId"] = this.buchtId;
        data["funktionHistoryId"] = this.funktionHistoryId;
        data["createdAtUtc"] = this.createdAtUtc;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface ISauBuchtDto {
    id?: number;
    buchtId?: number;
    funktionHistoryId?: number;
    createdAtUtc?: number;
    createdDate?: string | undefined;
}

export class SauDto implements ISauDto {
    id?: number;
    tierSysId?: string;
    halterbetrieb?: string | undefined;
    sauNrBetrieb?: string | undefined;
    sauNrPlaner?: number;
    sauTransponder?: number | undefined;
    lifeStages?: SauLifeStageDto[] | undefined;
    modifiedAtUtc?: number;

    constructor(data?: ISauDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tierSysId = _data["tierSysId"];
            this.halterbetrieb = _data["halterbetrieb"];
            this.sauNrBetrieb = _data["sauNrBetrieb"];
            this.sauNrPlaner = _data["sauNrPlaner"];
            this.sauTransponder = _data["sauTransponder"];
            if (Array.isArray(_data["lifeStages"])) {
                this.lifeStages = [] as any;
                for (let item of _data["lifeStages"])
                    this.lifeStages!.push(SauLifeStageDto.fromJS(item));
            }
            this.modifiedAtUtc = _data["modifiedAtUtc"];
        }
    }

    static fromJS(data: any): SauDto {
        data = typeof data === 'object' ? data : {};
        let result = new SauDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tierSysId"] = this.tierSysId;
        data["halterbetrieb"] = this.halterbetrieb;
        data["sauNrBetrieb"] = this.sauNrBetrieb;
        data["sauNrPlaner"] = this.sauNrPlaner;
        data["sauTransponder"] = this.sauTransponder;
        if (Array.isArray(this.lifeStages)) {
            data["lifeStages"] = [];
            for (let item of this.lifeStages)
                data["lifeStages"].push(item.toJSON());
        }
        data["modifiedAtUtc"] = this.modifiedAtUtc;
        return data;
    }
}

export interface ISauDto {
    id?: number;
    tierSysId?: string;
    halterbetrieb?: string | undefined;
    sauNrBetrieb?: string | undefined;
    sauNrPlaner?: number;
    sauTransponder?: number | undefined;
    lifeStages?: SauLifeStageDto[] | undefined;
    modifiedAtUtc?: number;
}

export class SauFunktionHistoryDto implements ISauFunktionHistoryDto {
    id?: number;
    funktionId?: number;
    recordId?: string;
    createdAtUtc?: number;

    constructor(data?: ISauFunktionHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.funktionId = _data["funktionId"];
            this.recordId = _data["recordId"];
            this.createdAtUtc = _data["createdAtUtc"];
        }
    }

    static fromJS(data: any): SauFunktionHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SauFunktionHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["funktionId"] = this.funktionId;
        data["recordId"] = this.recordId;
        data["createdAtUtc"] = this.createdAtUtc;
        return data;
    }
}

export interface ISauFunktionHistoryDto {
    id?: number;
    funktionId?: number;
    recordId?: string;
    createdAtUtc?: number;
}

export class SauLifeStageDescriptorDto implements ISauLifeStageDescriptorDto {
    tierSysId?: string;
    belegNr?: number | undefined;
    ammenObjectId?: string | undefined;

    constructor(data?: ISauLifeStageDescriptorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tierSysId = _data["tierSysId"];
            this.belegNr = _data["belegNr"];
            this.ammenObjectId = _data["ammenObjectId"];
        }
    }

    static fromJS(data: any): SauLifeStageDescriptorDto {
        data = typeof data === 'object' ? data : {};
        let result = new SauLifeStageDescriptorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tierSysId"] = this.tierSysId;
        data["belegNr"] = this.belegNr;
        data["ammenObjectId"] = this.ammenObjectId;
        return data;
    }
}

export interface ISauLifeStageDescriptorDto {
    tierSysId?: string;
    belegNr?: number | undefined;
    ammenObjectId?: string | undefined;
}

export class SauLifeStageDto implements ISauLifeStageDto {
    id?: number;
    lifeStageType?: SauLifeStageTypeEnum;
    belegdatum?: number;
    buchten?: SauBuchtDto[] | undefined;
    funktionenHistory?: SauFunktionHistoryDto[] | undefined;
    belegNr?: number | undefined;
    ammenObjectId?: string | undefined;
    mumien?: string | undefined;
    abferkeldatum?: number | undefined;
    absetzdatum?: number | undefined;

    constructor(data?: ISauLifeStageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lifeStageType = _data["lifeStageType"];
            this.belegdatum = _data["belegdatum"];
            if (Array.isArray(_data["buchten"])) {
                this.buchten = [] as any;
                for (let item of _data["buchten"])
                    this.buchten!.push(SauBuchtDto.fromJS(item));
            }
            if (Array.isArray(_data["funktionenHistory"])) {
                this.funktionenHistory = [] as any;
                for (let item of _data["funktionenHistory"])
                    this.funktionenHistory!.push(SauFunktionHistoryDto.fromJS(item));
            }
            this.belegNr = _data["belegNr"];
            this.ammenObjectId = _data["ammenObjectId"];
            this.mumien = _data["mumien"];
            this.abferkeldatum = _data["abferkeldatum"];
            this.absetzdatum = _data["absetzdatum"];
        }
    }

    static fromJS(data: any): SauLifeStageDto {
        data = typeof data === 'object' ? data : {};
        let result = new SauLifeStageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lifeStageType"] = this.lifeStageType;
        data["belegdatum"] = this.belegdatum;
        if (Array.isArray(this.buchten)) {
            data["buchten"] = [];
            for (let item of this.buchten)
                data["buchten"].push(item.toJSON());
        }
        if (Array.isArray(this.funktionenHistory)) {
            data["funktionenHistory"] = [];
            for (let item of this.funktionenHistory)
                data["funktionenHistory"].push(item.toJSON());
        }
        data["belegNr"] = this.belegNr;
        data["ammenObjectId"] = this.ammenObjectId;
        data["mumien"] = this.mumien;
        data["abferkeldatum"] = this.abferkeldatum;
        data["absetzdatum"] = this.absetzdatum;
        return data;
    }
}

export interface ISauLifeStageDto {
    id?: number;
    lifeStageType?: SauLifeStageTypeEnum;
    belegdatum?: number;
    buchten?: SauBuchtDto[] | undefined;
    funktionenHistory?: SauFunktionHistoryDto[] | undefined;
    belegNr?: number | undefined;
    ammenObjectId?: string | undefined;
    mumien?: string | undefined;
    abferkeldatum?: number | undefined;
    absetzdatum?: number | undefined;
}

export enum SauLifeStageTypeEnum {
    Undefined = "Undefined",
    Belegung = "Belegung",
    Ammen = "Ammen",
}

export class SauenResponseDto implements ISauenResponseDto {
    sauen?: SauDto[] | undefined;

    constructor(data?: ISauenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sauen"])) {
                this.sauen = [] as any;
                for (let item of _data["sauen"])
                    this.sauen!.push(SauDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SauenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SauenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sauen)) {
            data["sauen"] = [];
            for (let item of this.sauen)
                data["sauen"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISauenResponseDto {
    sauen?: SauDto[] | undefined;
}

export class SendDataExportRequestDto implements ISendDataExportRequestDto {
    /** The RecordsGroupId associated with single DataExport */
    recordsGroupId!: string;

    constructor(data?: ISendDataExportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsGroupId = _data["recordsGroupId"];
        }
    }

    static fromJS(data: any): SendDataExportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendDataExportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsGroupId"] = this.recordsGroupId;
        return data;
    }
}

export interface ISendDataExportRequestDto {
    /** The RecordsGroupId associated with single DataExport */
    recordsGroupId: string;
}

export class TokenRefreshRequestDto implements ITokenRefreshRequestDto {
    refreshToken!: string;

    constructor(data?: ITokenRefreshRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): TokenRefreshRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TokenRefreshRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface ITokenRefreshRequestDto {
    refreshToken: string;
}

export class TokenResponseDto implements ITokenResponseDto {
    token?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: ITokenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): TokenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface ITokenResponseDto {
    token?: string | undefined;
    refreshToken?: string | undefined;
}

/** Provides a response container for the translations */
export class TranslationsResponseDto implements ITranslationsResponseDto {
    /** Available translations */
    translations?: { [key: string]: { [key: string]: { [key: string]: string; }; }; } | undefined;

    constructor(data?: ITranslationsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (<any>this.translations)![key] = _data["translations"][key] !== undefined ? _data["translations"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): TranslationsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (<any>data["translations"])[key] = (<any>this.translations)[key];
            }
        }
        return data;
    }
}

/** Provides a response container for the translations */
export interface ITranslationsResponseDto {
    /** Available translations */
    translations?: { [key: string]: { [key: string]: { [key: string]: string; }; }; } | undefined;
}

export class UserDto implements IUserDto {
    id?: string | undefined;
    displayName?: string | undefined;
    displayOrder?: number;
    settings?: UserSettingsDto;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.displayOrder = _data["displayOrder"];
            this.settings = _data["settings"] ? UserSettingsDto.fromJS(_data["settings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["displayOrder"] = this.displayOrder;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserDto {
    id?: string | undefined;
    displayName?: string | undefined;
    displayOrder?: number;
    settings?: UserSettingsDto;
}

export class UserResponseDto implements IUserResponseDto {
    user?: UserDto;

    constructor(data?: IUserResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserResponseDto {
    user?: UserDto;
}

export class UserSettingsDto implements IUserSettingsDto {
    language?: string | undefined;

    constructor(data?: IUserSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): UserSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        return data;
    }
}

export interface IUserSettingsDto {
    language?: string | undefined;
}

export class UserSettingsRequestDto implements IUserSettingsRequestDto {
    userSettings!: UserSettingsDto;

    constructor(data?: IUserSettingsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userSettings = new UserSettingsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userSettings = _data["userSettings"] ? UserSettingsDto.fromJS(_data["userSettings"]) : new UserSettingsDto();
        }
    }

    static fromJS(data: any): UserSettingsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSettings"] = this.userSettings ? this.userSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserSettingsRequestDto {
    userSettings: UserSettingsDto;
}

export class UserSettingsResponseDto implements IUserSettingsResponseDto {
    userSettings?: UserSettingsDto;

    constructor(data?: IUserSettingsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userSettings = _data["userSettings"] ? UserSettingsDto.fromJS(_data["userSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserSettingsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSettings"] = this.userSettings ? this.userSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserSettingsResponseDto {
    userSettings?: UserSettingsDto;
}

export class UsersResponseDto implements IUsersResponseDto {
    users?: UserDto[] | undefined;

    constructor(data?: IUsersResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UsersResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsersResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUsersResponseDto {
    users?: UserDto[] | undefined;
}

export class WorkflowConfigurationDto implements IWorkflowConfigurationDto {
    workflowId?: number;
    configurationKey?: string | undefined;
    configurationValue?: string | undefined;

    constructor(data?: IWorkflowConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowId = _data["workflowId"];
            this.configurationKey = _data["configurationKey"];
            this.configurationValue = _data["configurationValue"];
        }
    }

    static fromJS(data: any): WorkflowConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowId"] = this.workflowId;
        data["configurationKey"] = this.configurationKey;
        data["configurationValue"] = this.configurationValue;
        return data;
    }
}

export interface IWorkflowConfigurationDto {
    workflowId?: number;
    configurationKey?: string | undefined;
    configurationValue?: string | undefined;
}

export class WorkflowConfigurationRequestDto implements IWorkflowConfigurationRequestDto {
    workflowConfigurationDtos?: WorkflowConfigurationDto[] | undefined;

    constructor(data?: IWorkflowConfigurationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workflowConfigurationDtos"])) {
                this.workflowConfigurationDtos = [] as any;
                for (let item of _data["workflowConfigurationDtos"])
                    this.workflowConfigurationDtos!.push(WorkflowConfigurationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkflowConfigurationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowConfigurationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workflowConfigurationDtos)) {
            data["workflowConfigurationDtos"] = [];
            for (let item of this.workflowConfigurationDtos)
                data["workflowConfigurationDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWorkflowConfigurationRequestDto {
    workflowConfigurationDtos?: WorkflowConfigurationDto[] | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}